export default __webpack_public_path__ + "static/media/KLbyProv.09122c31.png";